import { render, staticRenderFns } from "./DocuSignUpdateTemplateAdditionalDocument.vue?vue&type=template&id=e040b35c&"
import script from "./DocuSignUpdateTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"
export * from "./DocuSignUpdateTemplateAdditionalDocument.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports